<template>
  <div class="team-container light">
    <div class="content" ref="" @animationend.stop="animatinEnd"  @webkitAnimationEnd.stop="animatinEnd" :class="{active:loading}">
      <img :src="resources['teamBg'].src" class="bg"/>
      <div class="team-group" :class="[{enter:enter || selectTeam==team},{active:selectTeam==team , fix:team.fix}]" @webkitAnimationEnd.stop.prevent @animationEnd.stop.prevent   :style="{left:team.position.left,top:team.position.top}" v-for="(team ,index) in teams" :key="index">
        <div class="icon-plus" @click="handleActive(team)"></div>
        <div class="team-name" @click="handleActive(team)">
          <div class="team-cname">{{team.cname}}</div>
          <div class="team-ename">{{team.ename}}</div>
        </div>
        <div class="team-desc">
          <div class="team-desc-text">
            {{team.desc}}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
function px2rem($val,$base = 100){
  return ($val / $base) +'rem';
}
const TEAMS = [
  {
    cname: '策略部',
    ename: 'strategy',
    desc: '银都奥美策略部是基于“策略先行”的公司文化建立起来的，前期通过对客户需求进行深度的洞察分析，并给出精准的策略解决之道，为创意、媒介、网络、公关和活动执行相关部门的具体工作，给出明确的策略方向，让各部门可以有计划、有针对性的展开后续相关工作，从而系统化的解决客户品牌或产品的传播问题。',
    position: {
      left: px2rem("66") ,
      top: px2rem("235")
    },
    active:''
  },
  {
    cname: '创意部',
    ename: 'Creative',
    desc: '创意部是最重要的部门之一，现有员工150人，共有N个创意群组，工作范围包括在传统媒介（电视、广播、平面及户外）上对客户的品牌、促销进行创意和执行。产出包括tvc、微电影、宣传片、主视觉平面、VI、店陈设计、终端物料设计、广播广告等内容。',
    position: {
      left: px2rem("459") ,
      top: px2rem("144")
    },
    active:''
  },
  {
    cname: '媒介部',
    ename: 'medium',
    desc: '媒介部站在媒体市场的第一线，敏锐的捕捉媒介动态与趋势，与媒体密切沟通，为客户抓取一手传播资源。我们谈判为客户争取优势的传播资源回报并用强大的执行力落实到位，为客户提供高效优质的媒介购买服务。',
    position: {
      left: px2rem("693") ,
      top: px2rem("208")
    },
    active:''
  },
  {
    cname: '客户部',
    ename: 'account services',
    desc: '以“实效传播塑品牌”的品牌理念，秉承“客户利益第一”的服务观，服务通信、房产、快消、家电、汽车等多个行业，客户包括中国移动、咪咕游戏、咪咕动漫、银城国际、博世家电、海澜之家、洋河、长安马自达、蒙牛、中国体彩等。切实从客户需求出发，提供专业化的360整合传播服务，致力成为“更有价值的战略合作伙伴”。',
    position: {
      left: px2rem("396") ,
      top: px2rem("294")
    },
    active:''
  },
  {
    cname: '上海分公司',
    ename: 'Shanghai branch',
    desc: '上海公司位于上海三大主要商圈淮海路，静安寺和徐家汇的交界处—世纪商贸大厦。公司现有员工多人，主要业务包括广告创意，品牌策划，新媒体营销等多个领域。服务包括日化，通讯、快消以及B2B等多个行业，与上海家化，上海移动，利乐包装以及惠氏奶粉有着长期的合作关系。',
    position: {
      left: px2rem("1072") ,
      top: px2rem("263")
    },
    active:'',
    fix:true
  },
  {
    cname: '北京分公司',
    ename: 'BeiJing branch',
    desc: '银都奥美广告北京分公司位于朝阳区国贸商圈光华路9号光华路SOHO2期，近年来，北京分公司凭借专业的广告整合营销传播能力和快很准的执行能力，获得了众多客户的认可和信任。目前正为中国移动集团客户服务部、中国移动咪咕公司、中国移动政企公司、中国移动终端公司、中国移动北京分公司、中航资本控股股份有限公司、沃尔沃金融服务有限公司、沃尔沃卡车中国有限公司、长安马自达汽车有限公司等客户提供360度整合营销传播服务，帮助客户在品牌咨询、品牌传播、营销推广、广告创意、公关活动、媒介宣传、自媒体运营方面建立系统专业的传播体系，助力客户提升品牌知名度和美誉度。',
    position: {
      left: px2rem("737") ,
      top: px2rem("325")
    },
    active:''
  },
  {
    cname: '杭州分公司',
    ename: 'HanZhou branch',
    desc: '杭州分公司位于下城区深蓝广场1201，目前主要服务客户有中国移动浙江公司、咪咕数字传媒有限公司。',
    position: {
      left: px2rem("1283") ,
      top: px2rem("343")
    },
    active:'',
    fix:true
  },
  {
    cname: '户外部',
    ename: 'Outdoor',
    desc: '主要负责物料制作、展览会务活动、户外媒体投放工作。常规物料制作种类繁多，包括写真、喷绘及定制物料等。展览活动包括室内外大型会议、展览、活动的现场布置、流程环节的完整执行。户外媒介可投放全国范围机场、高铁、地铁等媒体，长期以来都与各级供应商保持良好合作关系。',
    position: {
      left: px2rem("489") ,
      top: px2rem("423")
    },
    active:''
  },
  {
    cname: '湖南分公司',
    ename: 'HuNan branch',
    desc: '银都奥美湖南分公司成立于2014年2月，专业团队近30人。近年来，湖南分公司凭借专业的广告整合传播能力和高效快速的执行能力，获得了众多客户的信赖和认可。目前正为中国移动湖南公司、中国移动江西公司、中移电子商务公司、中航信托股份有限公司、海普诺凯营养品有限公司、九江银行南昌分行等客户提供360度整合传播服务，帮助客户在品牌传播、营销推广、广告创意、公关活动、媒介宣传方面建立系统专业的传播体系，助力客户提升品牌知名度和美誉度。',
    position: {
      left: px2rem("892") ,
      top: px2rem("431")
    },
    active:''
  },
  {
    cname: '公关部',
    ename: 'public relation',
    desc: '我们的业务范围主要由公关传播，行动营销，舆情管理，危机公关四大模块组成。我们拥有的资源结构主要包含，原创资源，分发资源，IP资源，舆情资源。我们聚焦企业核心公关策略及内容营销和体验营销，在整合营销的基础上为各类客户提供定制化的品牌公关服务。',
    position: {
      left: px2rem("167") ,
      top: px2rem("452")
    },
    active:''
  }
];
export default {
  name: 'Team',
  data(){
    return {
      selectTeam:null,
      loading:false,
      enter:false,
      teams:[...TEAMS],
      resources:null
    }
  },
  created(){
    this.resources = this.$store.state.resources;
    this.remFix();
  },
  mounted(){
    this.loading = true;
  },
  
  beforeRouteLeave (to, from, next) {
    this.loading = false;
    next();
  },
  methods:{
    animatinEnd(){
     this.enter = true;
    },
    handleActive(team){
      if(this.selectTeam == team) {
        this.selectTeam = null;
        this.enter = true;
      }else {
        this.selectTeam = team;
        this.enter = false;
      }

    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../common/common.scss";
  .content {
    max-width: 1429px;
    width: px2percent(1429,1920);
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: auto;
    margin: auto;
    top: 50%;
    transform: translate(0,-40%);
    opacity: 0;
    &.active {
     animation: content_anim .5s linear forwards;
    }
   
  }
  .bg {
    width: 100%;
    height: auto;
  }

  @keyframes content_anim {
    0%{
      transform: translate3d(0,20%,0);
      opacity: 0;
    }
    100%{
      transform: translate3d(0,-40%,0);
      opacity: 1;
    }
  }
  .team-group {
    pointer-events: none;
    position: absolute;
    cursor: pointer;
    transform: translate3d(0,20px,0);
    opacity: 0;
    transition: all .5s linear;
  
    .team-name {
      font-size: px2rem(24);
      position: absolute;
      white-space: nowrap;
      line-height: 1;
      top: -1.2em;
      left: .5em;
      transition:all .5s linear;
      .team-ename{
        font-size: px2rem(18);
        margin-top: px2rem(10);
        text-transform: uppercase;
      }
    }

    &.fix {
      .team-desc {
        left: px2rem(-591-20);
        &:after {
          transform-origin: right center;
        }
      }
    }
    .team-desc {
      pointer-events: none;
      width: px2rem(591);
      text-align: justify;
      font-size: px2rem(24);
      padding: px2rem(4) 0 ;
      line-height: 1.5;
      color: #6b6b6b;
      position: relative;
      white-space: wrap;
      .team-desc-text {
        transform: translate3d(0,px2rem(-10),0);
        opacity: 0;
      }
      &:after {
        content: "";
        width: 100%;
        border-top: px2rem(2) solid #ee0a07;
        top: 0;
        left: 0;
        position: absolute;
        transform-origin: left center;
        transform: scaleX(.1);
        transition: all .5s linear;
      }
    }
    &.enter {
      transform: none;
      opacity: 1;
      pointer-events: auto;
      .team-desc:after {
        transform: scaleX(0);
      }
    }
    &.active {
      .team-desc-text {
        transform: none;
        opacity: 1;
        transition:all .5s linear;
      }
      .team-desc:after {
        transform: scaleX(1);
      }
      .team-name {
        transform: translate3d(0,-50%,0);
      }
      .icon-plus {
        transform: rotateZ(45deg);
      }
    }
    
  }
  .icon-plus{
    position: absolute;
    width: 0;
    height: 0;
    left: px2rem(-11);
    top: 0px;
    transition: all .5s linear;
    &:after,
    &:before{
      content: "";
      position: absolute;
      background: #ee0a07;
    }
    &:after {
      width: px2rem(2);
      height: px2rem(19);
      top: px2rem(-8);
    }
    &:before {
      width: px2rem(19);
      height: px2rem(2);
      left: px2rem(-8);
    }
  }

</style>
